export const myCafeteriaTranslationsHu = {
  MY_CAFETERIA_PAGE_TITLE: "Cafeteria egyenlegem és nyilatkozatom",
  MY_CAFETERIA_ACTIVE_HUNGARIANS_BENEFIT_INFO: "Figyelem! Az Aktív Magyarok esetében naptári félévenként legfeljebb 60.000 Ft adható kedvezményes adózású juttatásként. E felett nem kedvezményes juttatásnak számít.",
  MY_CAFETERIA_ADMIN_GUIDE: "MyCafeteria adminisztrátori kézikönyv",
  MY_CAFETERIA_USER_GUIDE: "MyCafeteria felhasználói kézikönyv",
  MY_CAFETERIA_CONFIRM_TITLE: "Biztos befejezi a nyilatkozatot?",
  MY_CAFETERIA_CONFIRM_TEXT: "A nyilatkozat befejezése után már nem tud új juttatást felvenni, vagy módosítani a meglévőket.",
  MY_CAFETERIA_FINISH_APPLICATION: "Nyilatkozat befejezése",
  MY_CAFETERIA_DISABLED_APPLICATION_PRINT_BUTTON: "A nyomtatása csak lezárt nyilatkozat esetében lehetséges",
  MY_CAFETERIA_VBK_DELETE_SUCCEEDED: "A VBK Szabályzat sikeresen törölve!",
  MY_CAFETERIA_VBK_UPLOAD_SUCCEEDED: "A VBK Szabályzat sikeresen feltöltve!",
  MY_CAFETERIA_BRUTTO: "Bruttó",
  MY_CAFETERIA_NETTO: "Nettó",
  MY_CAFETERIA_UPLOADS: "Feltöltések",
  MY_CAFETERIA_NEW_REGULATION: "Új szabályzat",
  MY_CAFETERIA_BUDGET: "Keretösszeg",
  MY_CAFETERIA_ALL_AMOUNT: "Juttatások",
  MY_CAFETERIA_ALL_COSTS: "Költségek",
  MY_CAFETERIA_REMAINS: "Maradvány",
  MY_CAFETERIA_ORIGIN: "Rögzítve",
  MY_CAFETERIA_BENEFIT: "Juttatás",
  MY_CAFETERIA_MONTHS: "Hónapok",
  MY_CAFETERIA_PREVIOUS_BENEFITS: "Korábbi juttatások",
  MY_CAFETERIA_NUMBER_OF_MONTHS: "Hónapszám",
  MY_CAFETERIA_VALUE_OF_BENEFIT: "Juttatás értéke",
  MY_CAFETERIA_VBK_REGULATION: "VBK szabályzat",
  MY_CAFETERIA_NEW_BENEFIT: "Új juttatás",
  MY_CAFETERIA_ADD_NEW_BENEFIT: "Új juttatás hozzáadása",
  MY_CAFETERIA_EDIT_BENEFIT: "Juttatás szerkesztése",
  MY_CAFETERIA_START_OF_PERIOD: "Időszak kezdete",
  MY_CAFETERIA_END_OF_PERIOD: "Időszak vége",
  MY_CAFETERIA_DATA_FETCHING_ERROR: "Hiba történt az adatok lekérdezése közben!",
  MY_CAFETERIA_NET_AMOUNT: "Egyszeri nettó összeg",
  MY_CAFETERIA_MONTHLY_NET_AMOUNT: "Havi nettó összeg",
  MY_CAFETERIA_GROSS_AMOUNT: "Teljes bruttó összeg",
  MY_CAFETERIA_BENEFIT_ELEMENT_IS_NOT_DEFINED: "Aktuális juttatási elem nem áll rendelkezésre!",
  MY_CAFETERIA_SZEP_STATEMENT: "Nyilatkozat SZÉP kártya {{currentYear}}. évi igénybevételéről",
  MY_CAFETERIA_VBK_STATEMENT: "Nyilatkozat VBK juttatások felhasználásáról",
  MY_CAFETERIA_TAX_ID_SIGN_ID: "Adóazonosító jele",
  MY_CAFETERIA_STATEMENT_CONTRACT_CODE: "Törzsszám",
  MY_CAFETERIA_SUB_ACCOUNTS: "Alszámlák",
  MY_CAFETERIA_SZEP_STAT_OF_RES:
    "Tudomásul veszem, hogy a jelen nyilatkozatom esetleges valótlanságával összefüggésben minden felelősség kizárólagosan engem terhel.",
  MY_CAFETERIA_DATE_OF_SIGN: "Aláírás dátuma",
  MY_CAFETERIA_EMPLOYEE_SIGN: "Dolgozó aláírása",
  MY_CAFETERIA_FOR_THE_EMPLOYER: "Munkáltató részéről",
  MY_CAFETERIA_STATEINDUP:
    "A nyilatkozatot két példányban kell leadni, az egyik példány a magánszemélyt, a másik a társaságot illeti. A magánszemély a nyilatkozatot az elévülési idő lejártáig (5 év) köteles megőrizni.",
  MY_CAFETERIA_I_HAVE_NO_BENEFIT:
    "A {{thisYear}}. adóévben még nem részesültem az adott jogcímen más foglalkoztatótól juttatásban.",
  MY_CAFETERIA_SZEP_BENEFIT_NAME:
    "A jelenleg fennálló munkaviszonyommal párhuzamosan egyidejűleg más, adókötelezettséget keletkeztető jogviszonnyal is rendelkezem. Ezen párhuzamos jogviszonyom keretében a másik munkáltatómtól a {{thisYear}}. adóévben a következő  juttatásban részesülök, illetve várhatóan részesülni fogok.",
  MY_CAFETERIA_PLAN: "terv",
  MY_CAFETERIA_FACT: "tény",
  MY_CAFETERIA_USED_BENEFIT: "Felhasznált összeg",
  MY_CAFETERIA_COPY: "Másolás",
  MY_CAFETERIA_BRUTTO_INFO:
    "A nettó / bruttó összegek számításánál végzett kerekítések miatt a beírt összegek néhány forinttal változhatnak.",
  MY_CAFETERIA_MONTHLY_BRUTTO_INFO:
    "A teljes bruttó összegben szereplő érték több hónapot érintő juttatások esetén a hónapok számával szorzott teljes összeg.",
  MY_CAFETERIA_CAFETERIA_PLAN:
    "A tervként jelölt juttatás bruttó összege a keretből elkülönítésre kerül, azonban a pontos tény összeg ismeretében tényként jelölt költséggel kalkulál majd a program.",
  MY_CAFETERIA_SUM_OTHER_BENEFIT:
    "Amennyiben több kifizetőtől származik a juttatás, úgy összegezze azokat.",
  MY_CAFETERIA_OUT_OF_BOUNDS: "Ezzel az összeggel átlépi a keretet!",
  MY_CAFETERIA_MANDATORY_BENEFIT: "A juttatás megadása kötelező!",
  MY_CAFETERIA_MANDATORY_STARTING_MONTH: "A kezdő hónap megadása kötelező!",
  MY_CAFETERIA_MANDATORY_CLOSING_MONTH: "A záró hónap megadása kötelező!",
  MY_CAFETERIA_MANDATORY_MONTH: "A hónap megadása kötelező!",
  MY_CAFETERIA_MANDATORY_VALUE: "Az érték megadása kötelező!",
  MY_CAFETERIA_APPLIED_BENEFIT: "Erre az időszakra már kérelmezte ezt a juttatást!",
  MY_CAFETERIA_I_HAVE_BENEFIT:
    "A {{thisYear}}. adóévben az adott alszámlán más foglalkoztatótól az alábbiak szerint rendelkezem juttatással:",
}
